import type { ModuleContext, TenantInfo } from '@buildex/module-contract';
import { apiClient } from '../api/client';
import { sessionHasPermission } from '../session/model';
import type { Session } from '../session/types';

/** Собирает ModuleContext для manifest.onInit (вызывается shell'ом) */
export function buildModuleContext(session: Session | null, tenant: TenantInfo): ModuleContext {
  return {
    apiClient,
    tenant,
    hasPermission: (permission) => sessionHasPermission(session, permission),
  };
}
